export * from './lib/provider/compare-bar-provider'
// these components are always rendered with ssr: false, using the next dynamic import
// nx doesn't allow for a lib to be imported both statically and dynamically, so the no-ssr-components
// module wraps them in dynamic with ssr: false, and exports them from here
// export * from './lib/compare-bar.component'
// export * from './lib/compare-toggle-button.component'
export * from './lib/no-ssr-components'
export * from './lib/provider/compare-bar-provider.types'
